import { onConfigurableProductFragment } from '@pylot-data/hooks/product/graphql/Fragments/onConfigurableProductFragment'
import { ProductItemFragment } from '@pylot-data/hooks/product/graphql/Fragments/ProductItemFragment'
import { onGiftCardProductFragment } from '@pylot-data/hooks/product/graphql/Fragments/onGiftCardProductFragment'
import { onBundleProductFragment } from '@pylot-data/hooks/product/graphql/Fragments/onBundleProductFragment'
import { onProductUpCrosellFragment } from 'stores/ooka_usa_store/framework/pylot/hooks/product/graphql/Fragments/onProductUpCrosellFragment'
export const productDetailQuery = /* GraphQL */ `
    query products($filter: ProductAttributeFilterInput, $pageSize: Int = 16, $currentPage: Int = 1) {
      productDetail: products(
          filter: $filter
          pageSize: $pageSize
          currentPage: $currentPage
        ) {
            items {
                ${ProductItemFragment}
                short_description {
                    __typename
                    html
                }
                brand
                brand_text
                price_promo_text
                video
                marketing_block
                reward_message
                shipping_return
                is_cbd_product
                upsell_label
                crossell_label
                multi_buy_label
                description {
                    __typename
                    html
                }
                mp_label_data {
                    priority
                    label_template
                    label_image
                    same
                    list_template
                    list_image
                }
                media_gallery {
                    __typename
                    url
                    disabled
                    label
                    position
                    ... on ProductVideo {
                        video_content {
                            media_type
                            video_provider
                            video_url
                            video_title
                            video_description
                            video_metadata
                        }
                    }
                }
                price_tiers {
                  discount {
                    amount_off
                    percent_off
                  }
                  final_price {
                    currency
                    value
                  }
                  quantity
                }
                categories {
                    __typename
                    name
                    url_path
                    breadcrumbs {
                        __typename
                        category_uid
                        category_name
                        category_url_path
                    }
                }
                ${onConfigurableProductFragment}
                ${onBundleProductFragment}
                ${onGiftCardProductFragment}
                related_products {
                    ${ProductItemFragment}
                }
                meta_title
                meta_keyword
                meta_description
                canonical_url
                size_text
                ... on BundleProduct {
                  upsell_products {
                    ${onProductUpCrosellFragment}
                  }
                }
            }
        }
    }
`

export const productUpCrosellQuery = /* GraphQL */ `
    query products($filter: ProductAttributeFilterInput, $pageSize: Int = 16, $currentPage: Int = 1) {
      productDetail: products(
          filter: $filter
          pageSize: $pageSize
          currentPage: $currentPage
        ) {
            items {
                id
                upsell_products {
                    ${onProductUpCrosellFragment}
                }
                crosssell_products {
                    ${onProductUpCrosellFragment}
                }
            }
        }
    }
`
